@if (goodpieces.data$|async; as goodpieceData) {
  <div class="row">
    <div class="col-lg-12">
      <table class="table whitetable business-order-view-table business-order-create">
        <tbody>
          <tr>
            <td><strong>Anzahl Fe-Nutzen BA:</strong></td>
            <td><strong>{{ goodpieceData.utilize_quantity_bo }}</strong></td>
          </tr>
          @if (goodpieceData.good_utilize !== null && goodpieceData.good_utilize !== undefined) {
            <tr>
              <td><strong>Aktuelle Anzahl Fe-Nutzen BA:</strong></td>
              <td><strong>{{ goodpieceData.good_utilize }}</strong></td>
            </tr>
          }
          <tr>
            <td><strong>Menge BA:</strong></td>
            <td><strong>{{ additional.quantity|money }}</strong></td>
          </tr>
          <tr class="frame-table-box">
            <td><strong>Gutstück Menge:</strong></td>
            <td>
              @if (('good_piece.change'|HasPerm)) {
                <strong>
                  <a class="click" (click)="openGoodPieceModal()">{{ goodpieceData.goodpieces_bo|money }}</a>
                </strong>
              }
              @if (!('good_piece.change'|HasPerm)) {
                <strong>
                  {{ goodpieceData.goodpieces_bo|money }}
                </strong>
              }
            </td>
          </tr>
        </tbody>
        @if (goodpieceData.has_reproductions) {
          @for (gp of goodpieceData.reproduction_sets; track gp) {
            <tbody class="frame-table-box">
              @if (gp.original.status < 100 && !gp.original.date_deleted && !gp.original.date_storno) {
                <tr [business-order-view-goodpiece-box-element]="gp.original"
                  [business-order-view-goodpiece-box-element-current]="ba"
                  [business-order-view-goodpiece-box-element-reproduction]="null"
                  [ngClass]="{'blue-child': gp.requested}"
                  >
                </tr>
              }
              @for (bo of gp.reproductions; track bo) {
                <tr [business-order-view-goodpiece-box-element]="bo"
                  [business-order-view-goodpiece-box-element-current]="ba"
                  [business-order-view-goodpiece-box-element-reproduction]="bo.reproduction"
                  [ngClass]="{'blue-child': gp.requested}"
                  >
                </tr>
              }
            </tbody>
          }
        }
        <tfoot>
          @if (goodpieceData.has_reproductions) {
            <tr class="red-child">
              <td><strong>Gutstück Menge incl. Nachfertigung:</strong></td>
              <td>
                <strong>
                  {{ goodpieceData.goodpieces_reproduction|money }}
                </strong>
              </td>
            </tr>
          }
        </tfoot>
      </table>
    </div>
  </div>
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}
<loading-or-error #loadingOrError
  [loadingWrapper]="goodpieces"
  [errorMessage]="'Konnte Nutzeninformation nicht laden'">
</loading-or-error>
